import { Grain } from "@/components/Grain";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Intro } from "@/components/Intro";
import { Services } from "@/components/Services";
import { Work } from "@/components/Work";
import { Process } from "@/components/Process";
import { Pricing } from "@/components/Pricing";
import { About } from "@/components/About";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#050505]">
      <Grain />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Intro />
        <Services />
        <Work />
        <Process />
        <Pricing />
        <About />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
